import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledUserName = styled.span `
    color: ${props => props.theme.primary.base};
    font-weight: 600;
    margin-right: 6px;
`;
const UserName = ({ className, userName }) => (_jsx(StyledUserName, { className: className, children: userName }));
export default UserName;
